import React, {useMemo} from 'react';
import {PropTypes} from 'prop-types';
import {Clock as IconClock} from '@spothero/icons';
import {Box, Select, Icon} from '@spothero/ui';
import {TIME_DISPLAY, HALF_HOUR_TIME_VALUES} from '../../../common/constants';
import dayjs from 'dayjs';

const formattedTimes = HALF_HOUR_TIME_VALUES.map(time => {
    const timeArray = time.split(':');
    const formattedTime = dayjs()
        .hour(timeArray[0])
        .minute(timeArray[1])
        .second(timeArray[2])
        .format(TIME_DISPLAY);

    return {time, formattedTime};
});

const TimePicker = ({
    time,
    setTime,
    minimumTime = '00:00:00',
    disabled = false,
}) => {
    const trimmedTimes = useMemo(() => {
        const minimumIndex = formattedTimes.findIndex(
            timeOption => timeOption.time === minimumTime
        );

        if (minimumIndex > 0) {
            return formattedTimes.slice(minimumIndex);
        }

        return formattedTimes;
    }, [minimumTime]);

    return (
        <Box width="50%" maxWidth={80} minWidth={32}>
            <Select
                disabled={disabled}
                icon={<Icon as={IconClock} />}
                iconSize={18}
                iconColor="black"
                fontWeight="semibold"
                fontSize="base"
                value={time}
                id="TimePicker"
                onChange={e => setTime(e.target.value)}
                marginTop="1.8rem"
                marginX=".5rem"
            >
                {trimmedTimes.map(formattedTime => (
                    <option
                        value={formattedTime.time}
                        key={formattedTime.formattedTime}
                    >
                        {formattedTime.formattedTime}
                    </option>
                ))}
            </Select>
        </Box>
    );
};

TimePicker.propTypes = {
    time: PropTypes.string.isRequired,
    setTime: PropTypes.func.isRequired,
    minimumTime: PropTypes.string.isRequired,
    disabled: PropTypes.bool.isRequired,
};

export default TimePicker;
